import Vue from 'vue'
import axios from 'axios'
import store from './store/store' // vuex store instance
import router from './router'
import "./assets/filters";
import App from "../components/app";
import * as Sentry from "@sentry/vue";

/**
 |--------------------------------------------------------------------------
 | Require/import project bootstap.js file as well as additional package libraries
 |--------------------------------------------------------------------------
 */
require('./bootstrap');
import BootstrapVue from 'bootstrap-vue';
import Snotify from 'vue-snotify';
import snotify_config from './configs/snotify_config';
import moment from 'moment-mini';
import RouterTab from "vue-router-tab";
import 'vue-router-tab/dist/lib/vue-router-tab.css';
import Vuesax from 'vuesax';
import VueCookie from 'vue-cookie';

Vue.use(BootstrapVue);
Vue.use(Snotify, snotify_config);
Vue.use(RouterTab);
Vue.prototype.$moment = moment;
Vue.use(Vuesax);
Vue.use(VueCookie);


/** ==================================================================================================================================================
 * VEE-VALIDATE
 * ================================================================================================================================================== */
import {ValidationProvider, ValidationObserver, configure, extend} from 'vee-validate/dist/vee-validate.full.esm';
import vee_validate_config from './configs/vee_validate_config'
import './assets/vee_validate_extensions';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
configure(vee_validate_config);

import Intersect from 'vue-intersect'
Vue.component('Intersect', Intersect)

/** ==================================================================================================================================================
 * VUE MIXINS
 * ================================================================================================================================================== */
import app_mixins from './assets/mixins';
import logout from "components/auth/logout.vue";

Vue.mixin(app_mixins);

/** ==================================================================================================================================================
 * VUE DIRECTIVES
 * ================================================================================================================================================== */
Vue.directive('click-outside', {
 bind(el, binding, vnode) {
  el.clickOutsideEvent = function (event) {
   // here I check that click was outside the el and his childrens
   if (!(el === event.target || el.contains(event.target))) {
    // and if it did, call method provided in attribute value
    vnode.context[binding.expression](event);
   }
  };
  document.body.addEventListener('click', el.clickOutsideEvent)
 },
 unbind(el) {
  document.body.removeEventListener('click', el.clickOutsideEvent)
 },
});

/** ==================================================================================================================================================
 * EVENT BUS
 * ================================================================================================================================================== */
const EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
 $bus: {
  get: function () {
   return EventBus
  }
 }
});

/** ==================================================================================================================================================
 * AXIOS INTERCEPTORS
 * ================================================================================================================================================== */
/*
 * Authorisation header with access token for user
 */
axios.interceptors.request.use(function (config) {
 config['headers'] = {
  Authorization: 'Bearer ' + localStorage.getItem('access_token'),
  Accept: 'application/json',
 };
 config['verify'] = false;
 return config
}, error => {
 Promise.reject(error)
});

/**
 * Strip baseURL from URL
 *
 * @param config Object
 * @returns String
 */
// function getUrl(config) {
//  if (config.baseURL) {
//   return config.url.replace(config.baseURL, '');
//  }
//  return config.url;
// }

// Intercept all responses

let handling401 = false;

axios.interceptors.response.use(
    r => r,
    async err => {
        const res = err && err.response;
        if (res && res.status === 401) {
            const route = router.currentRoute || {};
            const onAuth = ['login','logout'].includes(route.name) || ['/login','/logout'].includes(route.path);

            if (!onAuth && !handling401) {
                handling401 = true;
                const redirect = route.fullPath || '/';

                try { await store.dispatch('clientLogout'); } catch (_) {}

                setTimeout(() => {
                    router.replace({ name: 'login', query: { redirect } })
                        .catch(() => {})
                        .finally(() => { handling401 = false; });
                }, 0);
            }
        }
        return Promise.reject(err);
    }
);

Sentry.init({
    Vue,
    environment: process.env.SENTRY_ENVIRONMENT,
    dsn: process.env.SENTRY_LARAVEL_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        Sentry.replayCanvasIntegration()
    ],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


/** ==================================================================================================================================================
 * Load view application on id 'app' entry point within laravel blade view file
 * ================================================================================================================================================== */
new Vue({
 router,
 store,
 template: '<App/>',
 components: {App},
}).$mount('#app');
